import { render, staticRenderFns } from "./PaginationPageInput.vue?vue&type=template&id=eb1684d6&"
import script from "./PaginationPageInput.vue?vue&type=script&lang=ts&"
export * from "./PaginationPageInput.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationPageInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports